import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';
import LazyLoad from 'react-lazyload';
const RamanujanClub = () => {
    useEffect(() => {
        document.title = 'Ramanujan Club -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Ramanujan Club </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li> 
                            <li>|</li>
                            <li> Ramanujan Club </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'> 
                <div className="row sports"> 
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club1.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club1.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club2.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club2.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club3.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club3.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club4.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club4.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club5.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club5.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club6.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club6.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club7.jpg">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club7.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <LazyLoad>
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club8.jpg">
                       <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/math-club8.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
               </a>
           </LazyLoad>
           </div> 
            </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default RamanujanClub